import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import PortalMaterialsCard from "../components/portal/PortalMaterialsCard";
import PortalPageHeading from "../components/portal/PortalPageHeading";
import { withPortalMember } from "../features/portal/hooks/usePortalLink";
import { usePortalPage } from "../features/portal/hooks/usePortalPage";
import { ROUTES } from "../routes";

/** Library: the files the school shared with the member; gone when the school switched materials off. */
const PortalLibraryPage = () => {
  const { t } = useTranslation();
  const { session, me, memberId, members, selectMember } = usePortalPage();

  if (!session) return null;
  // Built from the resolved member, not the store: the redirect runs before the pick is mirrored there.
  if (me && !me.features.materials) {
    return <Navigate to={withPortalMember(ROUTES.PORTAL, memberId, me.self.memberId)} replace />;
  }

  return (
    <section className="mx-auto w-full max-w-3xl px-4 py-8">
      <PortalPageHeading
        title={t("portal.library.title")}
        intro={t("portal.library.intro")}
        members={members}
        memberId={memberId}
        onSelectMember={selectMember}
      />
      {memberId && me && (
        <PortalMaterialsCard
          memberId={memberId}
          canUpload={me.features.materialUploads}
          wardName={members.find((member) => member.memberId === memberId && !member.isSelf)?.firstName ?? null}
        />
      )}
    </section>
  );
};

export default PortalLibraryPage;
